import request from '../request'

export default {
  deleteImagenInfraestructura(data) {
    return request.delete(`infraestructura_imagen/${data.ID_INFRAESTRUCTURA}/${data.ID_INFRAESTRUCTURA_IMAGEN}`)
  },
  getImagenesInfraestructura(data) {
    return request.get(`infraestructura_imagen/${data}`)
  },
  setImagenesInfraestructura(data) {
    return request.post(`infraestructura_imagen/${data.ID_INFRAESTRUCTURA}`, data.imagenes)
  }
}
